import React from "react";
import MultiDatePicker from "./MultiDatePicker";
import RoomsAvailability from "./RoomsAvailability";
import PersonDetails from "./PersonDetails";
import { useTranslation } from "react-i18next";

const AvailabilityDetails = () => {
  const { t } = useTranslation();

  return (
    <div className="availability-sec details-availability mt-md-5 mb-md-5 mt-4 mb-4">
      <div className="container">
        <div className="inner-availability">
          <h2>{t("availabilityTitle")}</h2>
          <div className="availability-box inner-banner-top-details">
            <h4 className="mb-4">{t("availabilityQuestion")}</h4>

            <div className="second-tabs-form d-flex flex-wrap align-items-center gap-2">
              <div className="calendar-add-sec check-availability-all-sec d-flex align-items-center gap-2">
                <MultiDatePicker />
                <RoomsAvailability />
                <PersonDetails />
              </div>
              <div className="btn-btn-box">
                <a href="#" className="btn btn-primary">
                  {t("checkAvailability")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailabilityDetails;
